<template>
  <v-card class="skeleton-table elevation-1">
    <v-card-title v-if="showTitle" class="pa-2">
      <div class="skeleton-table-title skeleton-shimmer"></div>
    </v-card-title>
    <v-card-text class="pa-0">
      <table class="skeleton-table-body">
        <thead v-if="showHeader">
          <tr>
            <th v-for="n in columnCount" :key="'header-' + n" class="pa-2">
              <div class="skeleton-header-cell skeleton-shimmer"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rowCount" :key="'row-' + row">
            <td v-for="col in columnCount" :key="'cell-' + row + '-' + col" class="pa-2">
              <div class="skeleton-table-cell skeleton-shimmer" :style="getCellStyle(col)"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SkeletonTable',
  props: {
    rowCount: {
      type: Number,
      default: 5
    },
    columnCount: {
      type: Number,
      default: 5
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getCellStyle (col) {
      const widths = ['70%', '80%', '60%', '75%', '85%']
      return { width: widths[col % widths.length] }
    }
  }
}
</script>

<style scoped>
.skeleton-table {
  background-color: #ffffff;
}

.skeleton-table-body {
  width: 100%;
  border-collapse: collapse;
}

.skeleton-table-body thead th {
  border-bottom: 1px solid #e0e0e0;
}

.skeleton-table-body tbody tr {
  border-bottom: 1px solid #f0f0f0;
}

.skeleton-table-body tbody tr:last-child {
  border-bottom: none;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-table-title {
  height: 20px;
  width: 30%;
}

.skeleton-header-cell {
  height: 16px;
  width: 80%;
}

.skeleton-table-cell {
  height: 14px;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SkeletonTable.vue